import _ from 'lodash'

export const stages = [
  { value: 'idea', label: 'Idea', longLabel: 'Idea (Concept)' },
  { value: 'pre_seed', label: 'Pre-seed', longLabel: 'Pre-seed (Prototype)' },
  { value: 'seed', label: 'Seed', longLabel: 'Seed (BETA)' },
  {
    value: 'early_growth',
    label: 'Early Growth',
    longLabel: 'Early Growth (MVP)',
  },
  { value: 'growth', label: 'Growth', longLabel: 'Growth (Full Product)' },
  { value: 'maturity', label: 'Maturity', longLabel: 'Maturity' },
]

export const stageChoiceByValue = _.keyBy(stages, 'value')

export function getStartupStages() {
  return stages
}

export function getStageLabel(stage) {
  const choice = stageChoiceByValue[stage]

  return choice ? choice.label : ''
}
